/* global define */

define('views/AdvancedSearchBarView',[
    'jquery',
    'underscore',
    'backbone',
    'bootstrap-multiselect',
    'views/DropdownView',
    'text!templates/views/AdvancedSearchBar.html',
    'jquery.easing'
], function($, _, Backbone, bootstrapmultiselect, DropdownControl, template) {

    'use strict';

    var View = Backbone.View.extend({
        selects: [],
        events: {
            'click .selectAll': 'onSelectAll',
            'click .selectNone': 'onSelectNone',
            'click .btn-close': 'hide',
            'click .btn-reset': 'reset'
        },
        initialize: function() {

            // Bind All
            _.bindAll(this);

            this.$window = $(window);

            this.advancedControls = this.options.gmapsearch.advanced_controls;

            this.$window.on('resize', this.render);

        },
        reset: function() {
            this.$el.find('.selectNone').click();
            this.updateToggleButton();
        },
        hide: function() {
            this.$view.slideUp(200);
            $('html').off('click', this.clickListener);
        },
        updateToggleButton: function() {

            var $select, values, $dt;

            for (var i = 0; i < this.selects.length; i++) {

                $select = this.selects[i];
                $dt = $select.parent().parent().find('dt');
                values = $select.val();

                if (values && values.length > 0) {
                    // DON'T LIKE THIS
                    $('.toggleAdvancedButton').css('color', '#d14');
                    $dt.css('color', '#d14');
                    break;
                } else {
                    $('.toggleAdvancedButton').css('color', '');
                    $dt.css('color', '');

                }

            }

        },
        clickListener: function(event) {

            // Autohide!
            if ($(event.target).parents().index(this.$el) == -1) {
                if (this.$el.is(":visible")) {
                    this.hide();
                }
            }
        },
        show: function() {
            var self = this;

            this.$view.css('top', this.$topSearchBarView.height() + 'px');
            this.$view.slideDown(200, function() {
                $('html').on('click', self.clickListener);
            });


        },
        toggle: function() {
            if (this.$view.is(':visible')) {
                this.hide();
            } else {
                this.show();
            }
        },
        selectNone: function($select) {
            $select.find('option').each(function() {
                $select.multiselect('deselect', $(this).val());
            });
            this.trigger('change', $select.attr('name'), '');
            this.updateAdvancedButton();
            this.updateToggleButton();
        },
        selectAll: function($select) {
            var values = [], 
                result = '';
            $select.find('option').each(function() {
                $select.multiselect('select', $(this).val());
                values.push($(this).val());
            });

            for (var i = 0; i < values.length; i++) {
                result += values[i] + '|';
            }
            result = result.substring(0, result.length - 1);

            this.trigger('change', $select.attr('name'), result);
            this.updateToggleButton();
            this.updateAdvancedButton();
        },
        onSelectAll: function(event) {
            this.selectAll($(event.target).closest('dl').find('.advancedControl'));
        },
        onSelectNone: function(event) {
            this.selectNone($(event.target).closest('dl').find('.advancedControl'));
        },
        onChange: function(element) {

            var $select = $(element).parent(),
                name = $select.attr('name'),
                values = $select.val(),
                result = '';

            if (values && values instanceof Array) {
                for (var i = 0; i < values.length; i++) {
                    result += values[i] + '|';
                }

                result = result.substring(0, result.length - 1);
            } else if (values) {
                result = values;
            }

            this.updateAdvancedButton();

            this.trigger('change', name, result);

            this.updateToggleButton();
        },
        updateAdvancedButton: function() {

            if (!this.$toggleAdvancedButton) {
                this.$toggleAdvancedButton = $('button.toggleAdvancedButton');
            }

            var $select = null,
                values = null;

            this.$toggleAdvancedButton.removeClass('btn-info');

            for (var i = 0; i < this.selects.length; i++) {

                $select = this.selects[i];
                values = $select.val();

                if (values && values.length > 0) {
                    this.$toggleAdvancedButton.addClass('btn-info');
                }

            }
        },
        addOption: function(advancedControl) {

            var $div = $('<div class="advancedControl"></div>'),
                $dl = $('<dl></dl>'),
                $select = $('<select class="advancedControl"></select>'),
                $option = null,
                values = advancedControl.values,
                value = null,
                appendSelectors = true,
                i;

            $select.attr('name', advancedControl.name);

            //$dl.append('<dt>' + advancedControl.label + '</dt>');

            if (advancedControl.ctrlType === 'multi') {
                $select.attr('multiple', 'multiple');
            } else if (advancedControl.ctrlType === 'single' ||
                advancedControl.ctrlType === 'size' ||
                advancedControl.ctrlType === 'year') {
                $option = $('<option></option>');
                $option.val('');
                $option.text('Any');
                $option.attr('title', 'Any');
                $select.append($option);

                appendSelectors = false;
            } else {
                console.error('unsupported ctrlType', advancedControl.ctrlType);
            }

            for (i = 0; i < values.length; i++) {
                value = values[i];

                if (value.name === '----' || value.value === '') {
                    continue;
                }

                $option = $('<option></option>');
                $option.val(value.value);
                $option.text(value.name);
                $option.attr('title', value.longName);
                $select.append($option);

            }

            if (advancedControl.ctrlType === 'size') {
                $option = $('<option></option>');
                $option.val('');
                $option.text('Other');
                $option.attr('title', 'Other');
                $select.append($option);
            }

            var $dd = null;

            if (appendSelectors) {
                $dd = $('<dt><div class="advancedControlTitle">' + advancedControl.label + '</div><div class="advancedControlSelectors"><a class="selectAll">All</a> <a class="selectNone">None</a></div></dt>');
                $dl.append($dd);
            } else {
                $dd = $('<dt><div class="advancedControlTitle">' + advancedControl.label + '</div><div class="advancedControlSelectors"><a class="selectNone">Any</a></div></dt>');
                $dl.append($dd);
            }
            $dd.attr('title', advancedControl.label.substring(0, advancedControl.label.length - 1));

            $dd = $('<dd></dd>');
            $dd.append($select);
            $dl.append($dd);

            $div.append($dl);

            if (this.$view.find('div.advancedControl').length %
                this.options.gmapsearch.advanced_panel_columns === 0) {
                this.$view.find('.controls').append('<div class="clear"></div>');
            }

            this.$view.find('.controls').append($div);

            var dropRight = false;
            if (this.$view.find('div.advancedControl').length %
                this.options.gmapsearch.advanced_panel_columns === 0) {
                dropRight = true;
            }

            // TODO store this 
            var viewWidth = 450;

            if (this.options.gmapsearch.advanced_panel_columns === 4) {
                viewWidth = 520;
            }

            var width = (viewWidth - 45) / this.options.gmapsearch.advanced_panel_columns;

            $select.multiselect({
                maxHeight: 150,
                buttonWidth: width + 'px',
                onChange: this.onChange,
                dropRight: dropRight
            });

            if (advancedControl.value) {
                this.selectNone($select);
                values = advancedControl.value.split('|');
                for (i = 0; i < values.length; i++) {
                    $select.multiselect('select', values[i]);
                }

                this.trigger('change', advancedControl.name, advancedControl.value);
            }

            this.selects.push($select);
        },
        addOptions: function() {

            if (!this.advancedControls) {
                return;
            }

            for (var i = 0; i < this.advancedControls.length; i++) {
                this.addOption(this.advancedControls[i]);
            }

            this.updateToggleButton();

            /*
			for (var i = 0; i < advancedControls.length; i++) {
					// }
					/*
dropdown = new DropdownControl({
id:advancedControl.name,
title:advancedControl.label,
name:advancedControl.name,
options: options,
align:advancedControl.align,
value:advancedControl.value,
data:advancedControl});

dropdown.on("change", this.onDropboxChange);
this.advancedDropdowns.push(dropdown);

$dropdownContainer.append(dropdown.render().el);



					if($select){
						$select.multiselect({
							buttonClass: 'btn btn-mini',

						});
					}
					//buttonText: advancedControl.name
				}*/

        },
        render: function() {

            if (!this.view) {
                this.$el.html(template);
                this.$view = this.$el.find('#advancedSearchBarView');
                this.addOptions();
            }

            var windowWith = this.$window.width(),
                viewWidth = '450';

            this.$topSearchBarView = $('#topSearchBarView');

            if (this.options.gmapsearch.advanced_panel_columns === 4) {
                viewWidth = '520';
            }

            this.$view.css('top', this.$topSearchBarView.height() + 'px');
            this.$view.css('left', ((windowWith / 2) - (viewWidth / 2)) + 'px');
            this.$view.css('width', viewWidth + 'px');

            this.$el.find('button.multiselect')
                .css('margin', '0')
                .css('padding', '0')
                .css('font-size', '8pt');

            return this;
        }


    });
    return View;
});

